import { AutogenModelHubtranFieldList, AutogenRowHubtranFieldList } from "./autogen/AutogenModelHubtranFieldList";

export class ModelHubtranFieldList extends AutogenModelHubtranFieldList<RowHubtranFieldList> {
	constructor() {
		super(RowHubtranFieldList);
	}
}

export class RowHubtranFieldList extends AutogenRowHubtranFieldList {
}